import React from "react";
import "./style/button.css";

const Button = () => {
  return (
    <>
      <button>Оставить заявку</button>
    </>
  );
};

export default Button;
